<ng-container *ngFor="let err of errorMessages">
  {{ err }}
</ng-container>
